import * as React from "react";
import { SVGProps } from "react";

const Request = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 141" {...props}>
    <path
      fill="#008c62"
      d="M87.65 79.31 123.07 44a14.07 14.07 0 0 0 4.14-10l.06-28.54a5.71 5.71 0 0 0-1.58-3.93l-67.95 67.8a14.08 14.08 0 0 0 0 20l47.91 47.76a14.1 14.1 0 1 0 19.9-20Z"
    />
    <path
      fill="#00e6a0"
      d="M121.73 0H15C6.37 0 0 6.52 0 15.42v111.35a14.17 14.17 0 0 0 14.36 14.35 14.11 14.11 0 0 0 14.35-14.35v-99.3h71l26-25.87a5.45 5.45 0 0 0-3.98-1.6Z"
    />
  </svg>
);

export default Request;
